// Refresh free-gift prices after Ajax cart changes using Shopify's cart-aware Liquid output.
(() => {
  // Bundle product pages have no freebie prices to update. Leave their
  // add-to-cart flow and third-party popup listeners completely untouched.
  if (!document.querySelector('[data-bundle-freebie-price]') &&
      document.body.dataset.bundleFreebieSlots === undefined) return;

  let timer;
  let refreshId = 0;
  const globoOriginalPrices = new WeakMap();

  function refreshGloboPrices() {
    const slots = Number(document.body.dataset.bundleFreebieSlots || 0);
    const globoPrices = document.querySelectorAll('#gf-products .card-information > .price');

    for (const price of globoPrices) {
      if (slots > 0) {
        if (price.querySelector('.price__bundle-freebie')) continue;
        price.classList.remove('price--bundle-freebie');

        const currentPrice = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        if (!currentPrice) continue;

        globoOriginalPrices.set(price, price.innerHTML);
        const amount = currentPrice.textContent.trim();
        const container = document.createElement('div');
        container.className = 'price__container';
        const freebie = document.createElement('div');
        freebie.className = 'price__bundle-freebie';
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = 'Free with a Set Bundle in your cart. One free gift per bundle. Regular price:';
        const free = document.createElement('span');
        free.className = 'price-item price-item--sale';
        free.textContent = 'FREE';
        const regular = document.createElement('s');
        regular.className = 'price-item price-item--regular';
        regular.textContent = amount;
        freebie.append(label, free, regular);
        container.append(freebie);
        price.replaceChildren(container);
        price.classList.add('price--bundle-freebie');
      } else if (price.classList.contains('price--bundle-freebie')) {
        const original = globoOriginalPrices.get(price);
        if (original) price.innerHTML = original;
        price.classList.remove('price--bundle-freebie');
      }
    }
  }

  if (document.body.dataset.bundleFreebieSlots !== undefined) {
    let updateQueued = false;
    const observer = new MutationObserver(() => {
      if (updateQueued) return;
      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        refreshGloboPrices();
      });
    });
    observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    refreshGloboPrices();
  }

  async function refreshFreebiePrices() {
    const prices = [...document.querySelectorAll('[data-bundle-freebie-price]')];
    if (!prices.length && document.body.dataset.bundleFreebieSlots === undefined) return;

    const thisRefresh = ++refreshId;
    const url = new URL(window.location.href);
    url.searchParams.set('_freebie_price_refresh', Date.now().toString());

    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok || thisRefresh !== refreshId) return;

      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (thisRefresh !== refreshId) return;

      if (page.body.dataset.bundleFreebieSlots !== undefined) {
        document.body.dataset.bundleFreebieSlots = page.body.dataset.bundleFreebieSlots;
        refreshGloboPrices();
      }

      const nextPrices = [...page.querySelectorAll('[data-bundle-freebie-price]')];
      const pricesByKey = new Map();
      for (const price of nextPrices) {
        const key = price.dataset.bundleFreebieKey;
        if (!pricesByKey.has(key)) pricesByKey.set(key, price);
      }

      for (const price of prices) {
        if (!price.isConnected) continue;
        const next = pricesByKey.get(price.dataset.bundleFreebieKey);
        if (!next) continue;
        price.innerHTML = next.innerHTML;
        price.classList.toggle('price--bundle-freebie', next.classList.contains('price--bundle-freebie'));
      }
    } catch (error) {
      // Keep the current server-rendered price if the refresh cannot complete.
    }
  }

  for (const eventName of ['cart-add', 'cart-remove', 'cart-update']) {
    document.addEventListener(eventName, () => {
      clearTimeout(timer);
      timer = setTimeout(refreshFreebiePrices, 150);
    });
  }
})();
